import React from "react";
import { Col, Container, Row } from "react-bootstrap";

export default function About() {
    return (
        <>
            <div className="about_bg">
                <div className="about-maincontent">
                    <Container>
                        <Row>
                            {/* Left Section */}
                            <Col sm={12} md={12} lg={6} className="about-left">
                                <div className="images-container">
                                    <div className="image-large">
                                        <img
                                            src="images/new collage-01.jpg"
                                            alt="Couple traveling"
                                            className="img-fluid large-img"
                                            draggable="false"
                                        />
                                    </div>
                                    <div className="images-parts">
                                        <Row>
                                            <Col sm={12} md={12} lg={6}>
                                                <div className="success-rate">
                                                    {/* <h1>100% </h1>
                                                    <h6>Successful Visa Process Rate</h6> */}
                                                </div>

                                            </Col>
                                            <Col sm={12} md={12} lg={6}>
                                                <div className="image-small">
                                                    <img
                                                        src="images/new collage-02.jpg"
                                                        alt="Man smiling"
                                                        className="img-fluid small-img"
                                                        draggable="false"
                                                    />
                                                </div>
                                            </Col>
                                        </Row>

                                    </div>
                                </div>

                            </Col>

                            {/* Right Section */}
                            <Col sm={12} md={12} lg={6} className="about-right">
                                <div className="about-content">
                                    <h6 className="about-us-title"><i class="fa-regular fa-paper-plane" style={{ color: '#b80505', transform: 'rotate(45deg)' }}></i> ABOUT US <i class="fa-solid fa-earth-americas" style={{ color: '#b50808' }}></i></h6>
                                    <h1 className="about-heading">
                                        Adapting for Success in a Rapidly Changing Business Landscape
                                    </h1>
                                    <h6 className="about-description" style={{ fontSize: '18px' }}>
                                        In today’s fast-evolving markets, businesses face constant disruption—from shifting customer
                                        expectations and emerging technologies to increased competition from agile new
                                        players. Navigating these challenges requires a clear vision, strategic
                                        action, and robust operational support.<br />
                                        Our expert consultants specialize in vendor management, pricing, budget planning, and administrative excellence to help you reach your goals.<br />

                                        Ready to grow? Contact us to build a sustainable, competitive edge in the digital era.

                                    </h6>
                                    {/* <ul className="about-list">
                                        <li>
                                            <i class="fa-solid fa-circle-check" style={{ color: "#B80404" }}></i>Lorem Ipsum has
                                            been the industry's standard dummy
                                        </li>
                                        <li>
                                            <i class="fa-solid fa-circle-check" style={{ color: "#B80404" }}></i>Many desktop
                                            publishing packages and web pages
                                        </li>
                                    </ul> */}
                                    <div className="experience-container">
                                        <div className="line"></div> {/* Top horizontal line */}
                                        <div className="experience">
                                            <img src="images/experience.jpg" alt="Experience" draggable="false" />
                                            <h4>Proven expertise backed by years of success.</h4>
                                        </div>
                                        <div className="line"></div> {/* Bottom horizontal line */}
                                    </div>
                                    <div className="contact">
                                        <button className="btn view-more-btn">
                                            VIEW MORE
                                        </button>
                                        {/* <div className="cont-details">
                                            <div className="phone-icon">
                                                <i className="fa-solid fa-phone alarm" style={{ color: "#b80505" }}></i>
                                            </div>
                                            <div className="phone-no">
                                                <h5>Call Any Time</h5>
                                                <p>+1 (647) 716-1330</p>
                                            </div>
                                        </div> */}

                                    </div>

                                </div>
                            </Col>
                        </Row>
                    </Container>
                </div>
            </div>
        </>
    );
}
